
<template>
    <section v-if="isVisibleOnSmallScreens" class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns">
                    <div class="column is-4 is-offset-4">
                        <form @submit.prevent="handleLogin">
                            <!-- <p class="has-text-centered"><img src="/public/img/logo.png" style="max-width: 100%"></p> -->

                            <p class="has-text-centered logo mb">Ordino</p>
                            <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                                <o-input placeholder="email@example.com" v-model:model-value="form.email" autofocus></o-input>
                            </o-field>

                            <o-field label="Password" :type="fieldType('password')" :message="getError('password')">
                                <o-input password-reveal type="password" placeholder="" :class="'reveal-external'" v-model:model-value="form.password"></o-input>
                            </o-field>

                            <div class="field">
                                <o-checkbox v-model="form.remember">Remember me</o-checkbox>
                            </div>

                            <router-link class="button is-dark" :to="{ name: 'send-reset-password-link' }">
                                <span class="icon">
                                  <i class="fa fa-lock"></i>
                                </span>
                                <span>Reset password</span>
                            </router-link>

                            <button type="submit" class="button is-primary is-pulled-right" v-submit="submitting">
                                <span class="icon">
                                    <i class="fa fa-sign-in"></i>
                                </span>
                                <span>Sign In</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import HandlesForm from './../mixins/HandlesForm'
    import SmallScreensConfirmationMixin from '../mixins/SmallScreensConfirmation.js'

    export default {
        mixins: [SmallScreensConfirmationMixin, HandlesForm],

        data () {
            return {
                form: {email: '', password: '', remember: false}
            }
        },

        computed: {
            ...mapGetters(['currentUser'])
        },

        methods: {
            ...mapActions(['userLogin']),

            handleLogin () {
                let submit = this.wrapSubmit(this.userLogin)
                submit(this.form)
                    .then(res => {
                        let destination = res.data.data.role === 'employee' ?
                            '/projects' :
                            '/dashboard'

                        this.$router.push(destination)
                        return res
                    })
            }
        }
    }
</script>
